import { types } from 'mobx-state-tree'
import { ContentEdge } from 'src/api/models/Content/ContentEdge'
import { generateType } from 'src/api/models/utils/generateNodeType'
import { contentConnection } from 'src/constants/typenames'
export { Printedcircuitboard } from 'src/api/models/Content/Printedcircuitboard'

const ContentConnection = generateType(contentConnection).props({
  edges: types.optional(types.array(ContentEdge), [{}])
})

export { ContentConnection, ContentEdge }
